import { atom } from 'jotai';

export interface IprjExportTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
}

export const iprjExportTrackingAtom = atom<IprjExportTracker[]>([]);
